import React from 'react';
import { motion } from 'framer-motion';

const steps = [
  {
    num: "01",
    title: "Initial Consultation",
    desc: "Connect with our certified appraisers for a free consultation. We'll discuss your property needs and outline the appraisal process so you know exactly what to expect."
  },
  {
    num: "02",
    title: "Information & Document Collection",
    desc: "We gather key property details and any necessary documents from you—such as prior appraisals, floor plans, or relevant records—to ensure a comprehensive and accurate evaluation."
  },
  {
    num: "03",
    title: "Expert Valuation & Report Delivery",
    desc: "Our team conducts a thorough, market-based appraisal and prepares a clear, unbiased report. You'll receive your completed appraisal promptly, supporting confident real estate decisions."
  }
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="section-padding bg-white">
      <div className="container-custom">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-8 h-[2px] bg-gold"></div>
            <span className="text-gold font-semibold uppercase tracking-wider text-sm">How It Works</span>
            <div className="w-8 h-[2px] bg-gold"></div>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold">Let Us Guide You Through Your Property Appraisal</h2>
        </div>

        <div className="relative">
          {/* Connecting Line (Desktop) */}
          <div className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-[2px] bg-gray-100 -z-0">
             <motion.div 
               initial={{ width: 0 }}
               whileInView={{ width: '100%' }}
               viewport={{ once: true, margin: "-100px" }}
               transition={{ duration: 1.5, delay: 0.2 }}
               className="h-full bg-gold"
             />
          </div>

          <div className="grid lg:grid-cols-3 gap-10 relative z-10">
            {steps.map((step, idx) => (
              <motion.div 
                key={idx}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.3, duration: 0.6 }}
                className="relative flex flex-col items-center text-center lg:items-start lg:text-left"
              >
                {/* Number Circle */}
                <div className="w-24 h-24 rounded-full bg-white border-4 border-offwhite shadow-soft flex items-center justify-center mb-6 relative z-10 mx-auto lg:mx-0">
                  <div className="w-20 h-20 rounded-full bg-navy flex items-center justify-center">
                    <span className="text-3xl font-serif font-bold text-gold">{step.num}</span>
                  </div>
                </div>

                <h3 className="text-xl font-bold font-serif mb-4 text-navy">{step.title}</h3>
                <p className="text-muted leading-relaxed">
                  {step.desc}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;